import can from './Can'

/**
 * Permission check — the companion to `$can`, which only knows ROLES.
 *
 * The sign-in response has always carried `permissionRole` (every permission
 * granted to the user's roles); it simply was never stored. `store/User.js` now
 * persists it as `permissionUser`, and this reads it.
 *
 * SuperAdmin and service short-circuit to true. That mirrors
 * App\Support\Fleet\FleetCostVisibility on the backend exactly, and it is what
 * keeps an already-signed-in administrator from losing UI the moment this ships:
 * their localStorage predates `permissionUser`, so a pure permission check would
 * read false until they signed in again.
 *
 * Server-side is still the boundary. This only decides whether a control is
 * worth drawing — every gated field is also withheld by the API.
 *
 * @param {string|string[]} permissions One name, or a list treated as ANY-of.
 */
export default (permissions) => {
    if (can(['SuperAdmin', 'service'])) {
        return true;
    }

    if (!permissions) {
        return false;
    }

    let granted;
    try {
        granted = JSON.parse(window.localStorage.getItem('permissionUser'));
    } catch (err) {
        granted = null;
    }

    if (!Array.isArray(granted)) {
        return false;
    }

    const wanted = Array.isArray(permissions) ? permissions : [permissions];

    return wanted.some(permission => granted.includes(permission));
}
